import useFetch from '../Hooks/useFetch';
import { BsFillStarFill } from 'react-icons/bs';
import { Autoplay } from "swiper";
import 'swiper/css';



//import Swiper from 'swiper';
import { Swiper,SwiperSlide } from 'swiper/react';
const PhoneHero = ()=>{
    const key = process.env.REACT_APP_API_KEY;

    const {results} = useFetch(`https://api.themoviedb.org/3/movie/popular?api_key=${key}&language=en-US&page=1`);

    return <nav className='md:hidden px-2 mt-4'>
        {
            (results.length>0)?
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 10000,
                    disableOnInteraction: false,
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >
                {
                    results.map(item=>{
                        return <SwiperSlide key={item.id}>
                            <section className=' shadow p-1'>
                                <img alt='movie poster' src={`https://image.tmdb.org/t/p/original${item.backdrop_path}`}/>
                                <h2 className='text-headline dark:text-headline-dark text-md font-heading tracking-wide p-0.5 bg-background dark:bg-background-dark max-w-fit mt-2'>{item.title}</h2>
                                {/* <p className='text-paragraph text-sm font-body tracking-wider mt-2 p-0.5 bg-background'>{item.overview}</p> */}
                                <span className='flex flex-row text-headline dark:text-headline-dark font-heading text-sm mt-2'>
                                    <h4 className='bg-background dark:bg-background-dark'>{item.release_date}</h4>
                                    <h4 className='ml-2 bg-background dark:bg-background-dark flex flex-row items-center'><BsFillStarFill className="text-[orange]"/> {item.vote_average}</h4>
                                </span>
                            </section>
                        </SwiperSlide>
                    })
                }
            </Swiper>
            :
            null
        }
    </nav>
}

export default PhoneHero